<template>
    <div class="container-fluid" style="max-width: 1400px">
        <div class="row">
            <div class="col-md-6">
                <div>
                    <EmailMessageEditor
                      :marketing-message="message"
                      :media="props.media"
                      :mediaUploadUrl="props.mediaUploadUrl"
                      :locales="locales"
                      :default-locale="lang"
                      @message-updated="updatePreview($event)"
                      @lang-change="lang = $event; updatePreview(marketingMessage)"
                    >
                    </EmailMessageEditor>

                    <div v-if="templateOptions">
                        <hr>
                        <strong class="text-muted d-block mb-2">{{ $t('Email Options') }}</strong>
                        <TemplateOption v-for="(templateOption, i) in templateOptions"
                                         :key="i"
                                         :template-option="templateOption"
                                         :model-value="message.template_options?.[templateOption.name]"
                                         @update:model-value="updateTemplateOption($event)"
                        >
                        </TemplateOption>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div>
                    <div class="mw-100 border rounded mx-auto" style="width: 700px;">
                        <div class="p-2">
                            <h5 class="mb-0">{{ message.translations.find((translation) => translation.locale == lang)?.subject }}</h5>
                            <hr class="my-2">
                            <ul class="list-unstyled mb-0">
                                <li><small><strong>From :</strong> {{message.from_name}}</small></li>
                                <li v-if="message.from_email"><small><strong>Reply to:</strong> {{ message.from_email }}</small></li>
                            </ul>
                        </div>
                        <div style="height: 800px">
                          <form :action="previewUrl" ref="previewForm" method="post" target="preview_frame">
                              <input type="hidden" name="_token" :value="csrfToken">
                              <input type="hidden" name="template_options" :value="previewTemplateOptions">
                              <input type="hidden" name="message" :value="message.translations.find((translation) => translation.locale == lang)?.message">
                              <input type="hidden" name="lang" :value="lang">
                          </form>
                          <iframe class="w-100 h-100 border-0"
                                  name="preview_frame"
                                  src=""></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useDebounceFn } from '@vueuse/core';
  import EmailMessageEditor from "@/components/marketing-message/EmailMessageEditor.vue";
  import TemplateOption from "@/components/form-components/TemplateOption.vue";

const props = defineProps({
  csrfToken: {
    required: true,
  },
  marketingMessage: {
    default: () => ({})
  },
  oldSubjects: {
    default: () => ({})
  },
  oldMessages: {
    default: () => ({})
  },
  locales: {
    type: Array,
    required: true,
  },
  defaultLocale: {
    type: String,
    default: 'en'
  },
  templateOptions: {
    type: Array
  },
  previewUrl: {
    type: String,
    required: true,
  },
  media: {
    type: Array,
    default: () => []
  },
  mediaUploadUrl: {
    type: String,
    required: true
  },
});

const previewForm = ref(null);
const lang = ref(props.defaultLocale);

const message = ref({
    ...props.marketingMessage,
    translations: props.locales.map((locale) => {
        let translation = props.marketingMessage.translations.find((translation) => translation.locale === locale.value);
        return {
            ...translation,
            locale: locale.value,
            subject: props.oldSubjects?.[locale.value] ? props.oldSubjects[locale.value] : translation?.subject ?? '',
            message: props.oldMessages?.[locale.value] ? props.oldMessages[locale.value] : translation?.message ?? '',
        };
    })
});

const previewTemplateOptions = computed(() => {
    return JSON.stringify(message.value.template_options);
});

const updatePreview = useDebounceFn((value) => {
  previewForm.value.submit();
}, 500);

const updateTemplateOption = (templateOption) => {
    message.value.template_options = {
        ...message.value.template_options,
        [templateOption.name]: templateOption.value
    };
    updatePreview(message.value);
};

onMounted(() => {
    previewForm.value.submit();
});
</script>
